// extracted by mini-css-extract-plugin
module.exports = {"red":"FormFinish_red_sqSg8","blue":"FormFinish_blue_2RYDn","orange":"FormFinish_orange_1KJni","white":"FormFinish_white_3Rz44"};